const paymentStatus = {
  approved: "completed",
  pending: "pending"
};
export default paymentStatus;
